import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 64 64\" id=\"plus\">\n  <rect width=\"46\" height=\"10\" x=\"9\" y=\"27\" rx=\"4\" />\n  <rect width=\"10\" height=\"46\" x=\"27\" y=\"9\" rx=\"4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol